exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_QRCode_1pLYPc68Lr-CYhpdIn0CWz {\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 1px 6px 0 #88888896;\n\n}\n\n.IA_QRCodeImage_218_TLTT6dIfYCBs0i44L_ {\n  float: left;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}", ""]);

// Exports
exports.locals = {
	"IA_QRCode": "IA_QRCode_1pLYPc68Lr-CYhpdIn0CWz",
	"IA_QRCodeImage": "IA_QRCodeImage_218_TLTT6dIfYCBs0i44L_"
};